import { Engine } from "@babylonjs/core/Engines/engine";
import { Scene } from "@babylonjs/core/scene";

export interface BabylonRuntime {
  readonly engine: Engine;
  readonly scene: Scene;
}

export function createBabylonRuntime(
  canvas: HTMLCanvasElement,
): BabylonRuntime {
  const engine = new Engine(
    canvas,
    true,
    {
      preserveDrawingBuffer: false,
      stencil: false,
      alpha: true,
      premultipliedAlpha: false,
    },
    true,
  );
  const scene = new Scene(engine);

  return { engine, scene };
}
